import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Łączy klasy Tailwinda — szanuje precedencję ostatnich wpisów. shadcn helper. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
